<script setup lang="ts">
import { useDisplay } from 'vuetify';

const { activator, displayDoNotShowAgainInput = true } = defineProps<{
  activator: boolean
  displayDoNotShowAgainInput?: boolean
}>()
const emit = defineEmits(['close', 'after-leave', 'do-not-show-again', 'show-again'])

const { mobile } = useDisplay()
</script>

<template>
  <v-dialog
    :model-value="activator"
    :width="mobile ? undefined : '70%'"
    :max-width="mobile ? undefined : '700px'"
    :content-class="mobile ? '' : 'rounded-lg'"
    @after-leave="emit('after-leave')"
    @update:modelValue="
      (val) => {
        if (!val) emit('close')
      }
    "
  >
    <v-card rounded="lg" class="pa-4">
      <v-row no-gutters justify="end">
        <v-btn rounded="lg" size="small" color="pwt_off_white" flat>
          <v-icon color="pwt_light_grey" @click="emit('close')">mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-container class="px-0 px-sm-5 py-2 d-flex flex-column align-center">
        <slot></slot>
      </v-container>
      <v-row v-if="displayDoNotShowAgainInput" no-gutters justify="start" class="mt-0 px-1 px-sm-5 pb-5">
        <v-checkbox
          color="pwt_palatinate_blue"
          base-color="pwt_palatinate_blue"
          hide-details
          density="compact"
          @update:modelValue="
            (val) => {
              if (val) emit('do-not-show-again')
              else emit('show-again')
            }
          "
        >
          <template v-slot:label>
            <span class="text-pwt_palatinate_blue text-decoration-underline text-caption">
              Don't show again
            </span>
          </template>
        </v-checkbox>
      </v-row>
    </v-card>
  </v-dialog>
</template>
